import React, { Component, PropTypes } from 'react';

import './Toggle.scss';

export default class Toggle extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    checked: PropTypes.bool,
  };

  static defaultProps = {
    checked: false,
  };

  componentWillMount() {
    const id = `checkbox-${Math.random()}`;
    this.setState({ id });
  }

  handleClick = () => {
    this.props.onChange();
  };

  render() {
    const { checked } = this.props;
    const { id } = this.state;

    return (
      <div className="toggle">
        <input
          id={id}
          className="toggle__checkbox"
          type="checkbox"
          checked={checked}
          onChange={this.handleClick}
        />
        <label className="toggle__label" htmlFor={id} />
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Toggle/Toggle.jsx
 **/